"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedSprite = void 0;
var typescript_collections_1 = require("typescript-collections");
// TODO:SH: Make an "Animation" module containing this and SpriteAnimation
/**
 * Animated sprite
 * @todo SH: Make an "Animation" module containing this and SpriteAnimation
 */
var AnimatedSprite = /** @class */ (function (_super) {
    __extends(AnimatedSprite, _super);
    /**
     * Creates an instance of animated sprite.
     */
    function AnimatedSprite() {
        var _this = _super.call(this) || this;
        _this.anchor.set(0.5);
        _this._animations = new typescript_collections_1.Dictionary();
        _this._elapsed = -1;
        _this._frame = -1;
        _this._isPlaying = false;
        _this._isReversed = false;
        return _this;
    }
    Object.defineProperty(AnimatedSprite.prototype, "isPlaying", {
        /**
         * Gets whether is playing
         */
        get: function () {
            return this._isPlaying;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds animation
     * @param pKey
     * @param pSpriteAnimation
     * @returns animation
     */
    AnimatedSprite.prototype.addAnimation = function (pKey, pSpriteAnimation) {
        this._animations.setValue(pKey, pSpriteAnimation);
        return pSpriteAnimation;
    };
    /**
     * Plays animated sprite
     * @param pKey
     * @param [pReverse]
     */
    AnimatedSprite.prototype.play = function (pKey, pReverse) {
        if (pReverse === void 0) { pReverse = false; }
        var anim = this._animations.getValue(pKey);
        if (anim !== undefined) {
            this._isReversed = pReverse;
            this._isPlaying = true;
            this._elapsed = 0;
            this._activeAnimation = anim;
        }
        else {
            console.log("AnimatedSprite.play: Animation with key " + pKey + " not found");
        }
    };
    /**
     * Holds frame
     * @param pKey
     * @param [pFrame]
     */
    AnimatedSprite.prototype.holdFrame = function (pKey, pFrame) {
        if (pFrame === void 0) { pFrame = 0; }
        var anim = this._animations.getValue(pKey);
        if (anim !== undefined) {
            this._isReversed = false;
            this._isPlaying = false;
            this._elapsed = (pFrame / anim.frames) * anim.duration;
            this._activeAnimation = anim;
            this.updateFrame();
        }
        else {
            console.log("AnimatedSprite.holdFrame: Animation with key " + pKey + " not found");
        }
    };
    /**
     * Updates animated sprite
     * @param pDeltaTime
     */
    AnimatedSprite.prototype.update = function (pDeltaTime) {
        if (this._isPlaying) {
            this._elapsed += pDeltaTime;
            this.updateFrame();
        }
    };
    /**
     * Updates frame
     */
    AnimatedSprite.prototype.updateFrame = function () {
        var looped = false;
        var complete = false;
        if (this._elapsed >= this._activeAnimation.duration) {
            if (this._activeAnimation.isLooping) {
                looped = true;
                this._elapsed %= this._activeAnimation.duration;
            }
            else {
                complete = true;
                this._elapsed = this._activeAnimation.duration;
                this._isPlaying = false;
            }
        }
        var animPerc = this._elapsed / this._activeAnimation.duration;
        if (this._isReversed) {
            animPerc = 1 - animPerc;
        }
        var newFrame = Math.floor(animPerc * this._activeAnimation.frames);
        newFrame = Math.min(Math.max(newFrame, 0), this._activeAnimation.frames - 1);
        if (newFrame !== this._frame) {
            this._frame = newFrame;
            this.texture = this._activeAnimation.getFrame(this._frame);
        }
        // Delaying these calls to avoid any issues with destroying the item in these callbacks
        if (looped) {
            this._activeAnimation.fireOnLoop();
        }
        else if (complete) {
            this._activeAnimation.fireOnComplete(this._isReversed);
        }
    };
    return AnimatedSprite;
}(PIXI.Sprite));
exports.AnimatedSprite = AnimatedSprite;
//# sourceMappingURL=AnimatedSprite.js.map